import { Typography } from "@material-ui/core";
import * as React from "react";
import { DateField, Edit, ReferenceInput, required, SaveButton, SelectInput, SimpleForm, TextInput, Toolbar } from "react-admin";
import AuthorizedCheck from "../../components/Authorized/AuthorizedCheck";
import { commentStatus } from "../enums";

const CommentEditTitle = ({ record }: any) => {
  //   return <span>Comment: {record ? `"${record.name}"` : ""}</span>;
  return <span>Comment Edit</span>;
};

const VideoTitleByVideoId = (props) => {
  let filterVideo = props?.choices?.filter((row: any) => row?.id === props?.input?.value);

  return (
    <Typography variant="h6">
      Video Title: <u> {filterVideo[0]?.title} </u>
    </Typography>
  );
};

const CommentEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton disabled={props.pristine} />
  </Toolbar>
);

const CommentEdit = (props) => {
  return (
    <AuthorizedCheck>
      <Edit {...props} title={<CommentEditTitle />}>
        <SimpleForm toolbar={<CommentEditToolbar />}>
          <ReferenceInput label="Video Title" source="videoId" reference="videos" sort={{ field: "title", order: "ASC" }}>
            {/* self close */}
            <VideoTitleByVideoId />
          </ReferenceInput>
          <TextInput multiline source="userComment" validate={[required()]} />
          <SelectInput source="status" choices={commentStatus} />
          <TextInput source="creatorName" disabled />
          <DateField source="createdDate" />
        </SimpleForm>
      </Edit>
    </AuthorizedCheck>
  );
};

export default CommentEdit;
